export default __webpack_public_path__ + "img/22.asset.3675c335.jpeg";